import ActionTypes from '../constants/ActionTypes';

const updatePointSystem = (projectId, data = {}) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE,
  payload: {
    projectId,
    data,
  },
});

updatePointSystem.success = (pointSystem) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE__SUCCESS,
  payload: {
    pointSystem,
  },
});

updatePointSystem.failure = (projectId, error) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE__FAILURE,
  payload: {
    projectId,
    error,
  },
});

const updateBoardPointSystem = (boardId, data = {}) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE,
  payload: {
    boardId,
    data,
  },
});

updateBoardPointSystem.success = updatePointSystem.success;
updateBoardPointSystem.failure = (boardId, error) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE__FAILURE,
  payload: {
    boardId,
    error,
  },
});

export default {
  updatePointSystem,
  updateBoardPointSystem,
};
